/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ResourcePublishedCredentialSchema } from './ResourcePublishedCredentialSchema';

export const ListPublishedCredentialSchema: core.serialization.ObjectSchema<
    serializers.ListPublishedCredentialSchema.Raw,
    Truvity.ListPublishedCredentialSchema
> = core.serialization.object({
    items: core.serialization.list(ResourcePublishedCredentialSchema),
});

export declare namespace ListPublishedCredentialSchema {
    export interface Raw {
        items: ResourcePublishedCredentialSchema.Raw[];
    }
}
